import type { IconProps } from './types';

export const XMarkIcon: React.FC<IconProps> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M-422 -86C-422 -99.2548 -411.255 -110 -398 -110H98C111.255 -110 122 -99.2548 122 -86V362C122 375.255 111.255 386 98 386H-398C-411.255 386 -422 375.255 -422 362V-86Z" />
    <path d="M-398 -109H98V-111H-398V-109ZM121 -86V362H123V-86H121ZM98 385H-398V387H98V385ZM-421 362V-86H-423V362H-421ZM-398 385C-410.703 385 -421 374.703 -421 362H-423C-423 375.807 -411.807 387 -398 387V385ZM121 362C121 374.703 110.703 385 98 385V387C111.807 387 123 375.807 123 362H121ZM98 -109C110.703 -109 121 -98.7025 121 -86H123C123 -99.8071 111.807 -111 98 -111V-109ZM-398 -111C-411.807 -111 -423 -99.8071 -423 -86H-421C-421 -98.7025 -410.703 -109 -398 -109V-111Z" />
    <path d="M-5.5 10C-5.5 1.43959 1.43959 -5.5 10 -5.5C18.5604 -5.5 25.5 1.43959 25.5 10C25.5 18.5604 18.5604 25.5 10 25.5C1.43959 25.5 -5.5 18.5604 -5.5 10Z" />
    <path
      d="M13.5354 6.46446L6.46436 13.5355M13.5354 13.5355L6.46436 6.46442"
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
